import React, { ReactNode, MouseEventHandler } from 'react';
import { buttonSize, buttonTheme, getIconSize } from './utils';
import { ClipLoader } from 'react-spinners';

interface ButtonProps {
    theme: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'tertiary-primary';
    text: string;
    icon?: ReactNode; 
    onClick?: MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    loading?: boolean;
    className?: string;
    size?: 'sm' | 'md' | 'xs';
    iconSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'; 
    type?: "button" | "submit" | "reset" | undefined;
}

const Button = ({
    theme, text, icon, onClick,
    loading = false, disabled = false,
    className, size = 'md', iconSize, type
}: ButtonProps) => {
    let iconToRender: ReactNode = null;

    if (icon) {
        if (typeof icon === 'string') {
            iconToRender = <img src={icon} width={getIconSize(iconSize)} height={getIconSize(iconSize)} alt="" />;
        } else {
            iconToRender = icon;
        }
    }

    return (
        <button
            className={`flex items-center font-poppins justify-center transition-all hover:brightness-90 disabled:brightness-[60%] ease-in text-center gap-2 font-normal outline-none disabled:cursor-not-allowed
              ${className} ${buttonSize(size)}`}
            onClick={onClick}
            disabled={disabled || loading}
            type={type}
            style={buttonTheme(theme)}
        >
            {loading && <ClipLoader color='white' loading={loading} size={20} />} 
            {!loading && iconToRender} 
            {!loading && text} 
            {loading && text} 
        </button>
    );
};

export default Button;
